import React from 'react'
import { AuthProvider } from '@/context/AuthContext'
import { ToastProvider } from '@/context/ToastContext'
import { AppProvider } from '@/context/AppContext'

// SPA pengganti NextAuth SessionProvider: AuthProvider (fetch /api/auth/me) +
// ToastProvider + AppProvider. Urutan sama dengan V1 (Toast di atas App karena
// AppContext memakai useToast).
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <ToastProvider>
        <AppProvider>{children}</AppProvider>
      </ToastProvider>
    </AuthProvider>
  )
}
